<button class="{{color}}" [class.disabled]="disabled" (click)="handleAction()">
    <span *ngIf="icon" class="material-icons">{{ icon }}</span>
    <span>{{ label }}</span>
</button>